import { render } from "./LbrxKioskServicesPopup.vue?vue&type=template&id=2ebd1440&scoped=true"
import script from "./LbrxKioskServicesPopup.vue?vue&type=script&lang=js"
export * from "./LbrxKioskServicesPopup.vue?vue&type=script&lang=js"

import "./LbrxKioskServicesPopup.vue?vue&type=style&index=0&id=2ebd1440&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebd1440"]])

export default __exports__